<template>
  <modal>
    <template slot="modal-header">
      <div class="header-wrapper">
        <h2 class="section-heading">
          <template v-if="clientId"
            >Edit client</template
          >
          <template v-else
            >Create new client</template
          >
        </h2>
        <close-button @closeModal="closeModal"></close-button>
      </div>
    </template>
    <template slot="modal-body">
      <vue-form :state="formState" @submit.prevent="">
        <validate class="form-group col-12 c__modal--title c__editable">
          <field-messages
            class="invalid-feedback"
            name="title"
            show="$dirty && $invalid"
          >
            <div slot="required">Organisation name is required</div>
          </field-messages>
          <input
            type="text"
            required
            name="title"
            class="input-title"
            placeholder="Organisation Name"
            v-model="client.title"
            :disabled="!canEditMainFields()"
          />
          <div class="i__edit" v-if="canEditMainFields()">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 53.3 53.3"
              style="enable-background:new 0 0 53.3 53.3;"
              xml:space="preserve"
            >
              <path
                d="M51.7,14.7L38.6,1.6c-0.8-0.8-2.2-0.8-3,0l-34,34C1.2,36,1,36.5,1,37.1v13.1c0,1.2,1,2.1,2.1,2.1h13.1
                                c0.6,0,1.1-0.2,1.5-0.6l34-34C52.5,16.9,52.5,15.5,51.7,14.7z M15.3,48h-10V38l2.2-2.2l10,10L15.3,48z M20.5,42.8l-10-10L37.1,6.2
                                l10,10L20.5,42.8z"
              />
            </svg>
          </div>
        </validate>
        <tabs
          :tabs="tabs"
          :currentTab="currentTab"
          :wrapper-class="'tabs'"
          :tab-class="'tab-item'"
          :tab-active-class="'active'"
          :line-class="'tab-active-line'"
          @onClick="changeTab"
        />
        <div class="tab-content">
          <div v-if="currentTab === 'tab1'">
            <client-details
              :client="client"
              :canEditMainFields="canEditMainFields"
              :isDomainsValid="isDomainsValid"
              :isEmailValid="isEmailValid"
              :isEmailListValid="isEmailListValid"
              :australianStates="australianStates"
            />
          </div>
          <div v-if="currentTab === 'displayTab'">
            <client-display-config
              :client="client"
              :canEditDisplayConfig="canEditDisplayConfig"
            />
          </div>
          <div v-show="currentTab === 'imageTab'">
            <client-images
              :client="client"
              :canEditMainFields="canEditMainFields"
              ref="imageFormRef"
            />
          </div>
          <div v-if="currentTab === 'tab2'">
            <template>
              <div class="form-row">
                <div class="col-12">
                  <div class="space-between">
                    <div></div>
                    <form
                      id="client-search"
                      class="search-form campaigns-client-search"
                    >
                      <input
                        class="form-control"
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                        v-model="search"
                      />
                    </form>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <div v-if="filteredAgencies">
                      <div v-for="agency in filteredAgencies" :key="agency.id">
                        <div class="c__checkbox">
                          <input
                            type="checkbox"
                            v-bind:checked="agency.attached"
                            @change="addAgency(agency)"
                          />
                          <label>{{ agency.displayName }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <div v-if="unavailableAgencies">
                      <div
                        v-for="agency in unavailableAgencies"
                        :key="agency.id"
                      >
                        <div class="c__checkbox">
                          <input
                            type="checkbox"
                            disabled
                            checked
                            @change="addAgency(agency)"
                          />
                          <label>{{ agency.displayName }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div v-if="currentTab === 'tab3'">
            <template>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.propertyCreative160600"
                  />
                  <label>Property Creative 160 x 600</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.propertyCreative300600"
                  />
                  <label>Property Creative 300 x 600</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.propertyCreative300250"
                  />
                  <label>Property Creative 300 x 250</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.propertyCreative970250"
                  />
                  <label>Property Creative 970 x 250</label>
                </div>
              </div>

              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.propertyMetaAdPreview"
                  />
                  <label>Property Campaign Meta Ad Preview</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.officeCreative160600"
                  />
                  <label>Office Creative 160 x 600</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.officeCreative300600"
                  />
                  <label>Office Creative 300 x 600</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.officeCreative300250"
                  />
                  <label>Office Creative 300 x 250</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.officeCreative970250"
                  />
                  <label>Office Creative 970 x 250</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.officeMetaAdPreview"
                  />
                  <label>Office Campaign Meta Ad Preview</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.agentCreative160600"
                  />
                  <label>Agent Creative 160 x 600</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.agentCreative300600"
                  />
                  <label>Agent Creative 300 x 600</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.agentCreative300250"
                  />
                  <label>Agent Creative 300 x 250</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.agentCreative970250"
                  />
                  <label>Agent Creative 970 x 250</label>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="client.clientIntegration.agentMetaAdPreview"
                  />
                  <label>Agent Campaign Meta Ad Preview</label>
                </div>
              </div>
            </template>
          </div>
          <div v-if="currentTab === 'tab4'">
            <h3 class="section-heading">Default Payment Methods</h3>
            <div class="col-12">
              <div class="form-group">
                <table class="table table-bordered" v-if="client.agencies.data">
                  <tbody>
                    <tr>
                      <td>Property Campaigns</td>
                      <td>
                        <div class="c__checkbox inline">
                          <input
                            id="credit-card"
                            type="radio"
                            value="credit-card"
                            v-model="client.propertyCampaignPaymentOption"
                            :disabled="!canChangePaymentOption()"
                          />
                          <label class="round" for="credit-card"
                            >Credit Card</label
                          >
                        </div>
                        <div class="c__checkbox inline">
                          <input
                            id="trading-terms"
                            type="radio"
                            value="trading-terms"
                            v-model="client.propertyCampaignPaymentOption"
                            :disabled="!canChangePaymentOption()"
                          />
                          <label class="round" for="trading-terms"
                            >Trading Terms</label
                          >
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Agent Campaigns</td>
                      <td>
                        <div class="c__checkbox inline">
                          <input
                            id="credit-card"
                            type="radio"
                            value="credit-card"
                            v-model="client.agentCampaignPaymentOption"
                            :disabled="!canChangePaymentOption()"
                          />
                          <label class="round" for="credit-card"
                            >Credit Card</label
                          >
                        </div>
                        <div class="c__checkbox inline">
                          <input
                            id="trading-terms"
                            type="radio"
                            value="trading-terms"
                            v-model="client.agentCampaignPaymentOption"
                            :disabled="!canChangePaymentOption()"
                          />
                          <label class="round" for="trading-terms"
                            >Trading Terms</label
                          >
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Office Campaigns</td>
                      <td>
                        <div class="c__checkbox inline">
                          <input
                            id="credit-card"
                            type="radio"
                            value="credit-card"
                            v-model="client.officeCampaignPaymentOption"
                            :disabled="!canChangePaymentOption()"
                          />
                          <label class="round" for="credit-card"
                            >Credit Card</label
                          >
                        </div>
                        <div class="c__checkbox inline">
                          <input
                            id="trading-terms"
                            type="radio"
                            value="trading-terms"
                            v-model="client.officeCampaignPaymentOption"
                            :disabled="!canChangePaymentOption()"
                          />
                          <label class="round" for="trading-terms"
                            >Trading Terms</label
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h3 class="section-heading">Payment Method - Property Campaigns</h3>
            <div class="col-12">
              <div class="form-group">
                <table class="table table-bordered" v-if="client.agencies.data">
                  <tbody>
                    <template v-for="agency in client.agencies.data">
                      <tr v-if="agency.status != 'archived'" :key="agency.id">
                        <td>{{ agency.displayName }}</td>
                        <td>
                          <div class="c__checkbox inline">
                            <input
                              id="credit-card"
                              type="radio"
                              value="credit-card"
                              v-model="agency.propertyCampaignPaymentOption"
                              @change="updateAgency(agency)"
                              :disabled="!canChangePaymentOption()"
                            />
                            <label class="round" for="credit-card"
                              >Credit Card</label
                            >
                          </div>
                          <div class="c__checkbox inline">
                            <input
                              id="trading-terms"
                              type="radio"
                              value="trading-terms"
                              v-model="agency.propertyCampaignPaymentOption"
                              @change="updateAgency(agency)"
                              :disabled="!canChangePaymentOption()"
                            />
                            <label class="round" for="trading-terms"
                              >Trading Terms</label
                            >
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <h3 class="section-heading">Payment Method - Agent Campaigns</h3>
            <div class="col-12">
              <div class="form-group">
                <table class="table table-bordered" v-if="client.agencies.data">
                  <tbody>
                    <template v-for="agency in client.agencies.data">
                      <tr v-if="agency.status != 'archived'" :key="agency.id">
                        <td>{{ agency.displayName }}</td>
                        <td>
                          <div class="c__checkbox inline">
                            <input
                              id="credit-card"
                              type="radio"
                              value="credit-card"
                              v-model="agency.agentCampaignPaymentOption"
                              @change="updateAgency(agency)"
                              :disabled="!canChangePaymentOption()"
                            />
                            <label class="round" for="credit-card"
                              >Credit Card</label
                            >
                          </div>
                          <div class="c__checkbox inline">
                            <input
                              id="trading-terms"
                              type="radio"
                              value="trading-terms"
                              v-model="agency.agentCampaignPaymentOption"
                              @change="updateAgency(agency)"
                              :disabled="!canChangePaymentOption()"
                            />
                            <label class="round" for="trading-terms"
                              >Trading Terms</label
                            >
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <h3 class="section-heading">Payment Method - Office Campaigns</h3>
            <div class="col-12">
              <div class="form-group">
                <table class="table table-bordered" v-if="client.agencies.data">
                  <tbody>
                    <template v-for="agency in client.agencies.data">
                      <tr v-if="agency.status != 'archived'" :key="agency.id">
                        <td>{{ agency.displayName }}</td>
                        <td>
                          <div class="c__checkbox inline">
                            <input
                              id="credit-card"
                              type="radio"
                              value="credit-card"
                              v-model="agency.officeCampaignPaymentOption"
                              @change="updateAgency(agency)"
                              :disabled="!canChangePaymentOption()"
                            />
                            <label class="round" for="credit-card"
                              >Credit Card</label
                            >
                          </div>
                          <div class="c__checkbox inline">
                            <input
                              id="trading-terms"
                              type="radio"
                              value="trading-terms"
                              v-model="agency.officeCampaignPaymentOption"
                              @change="updateAgency(agency)"
                              :disabled="!canChangePaymentOption()"
                            />
                            <label class="round" for="trading-terms"
                              >Trading Terms</label
                            >
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12">
                <textarea
                  id="tradingTerms"
                  class="form-control"
                  v-model="client.tradingTerms"
                  :disabled="!canEditTradingTerms()"
                />
                <label for="tradingTerms">Trading Terms</label>
              </div>
            </div>

            <div class="col-10 form-group" v-if="cards && cards.length > 0">
              <div class="row">
                <div class="col-12">
                  <div>DEFAULT CARD</div>
                  <div
                    v-for="(card, index) in cards"
                    v-bind:key="index"
                    class="card-container space-between"
                  >
                    <span
                      >{{ card['brand'] }} **** **** **** {{ card['last4'] }} /
                      Exp: {{ card['exp_month'] }} -
                      {{ card['exp_year'] }}</span
                    >
                    <a
                      v-if="canChangeClientCard()"
                      href="#"
                      @click.prevent="removeCard(card)"
                      >Remove</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-10 form-group" v-else>
              <div class="row">
                <div class="col-12">
                  <credit-card-save
                    v-if="canChangeClientCard()"
                    @saveCard="saveCard"
                  ></credit-card-save>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'featuresTab'">
            <features-table :clientId="clientId"></features-table>
          </div>
        </div>
        <div class="modal-footer">
          <div class="c__btn--container">
            <button
              class="btn btn-tertiary"
              @click="
                deleteAction(
                  `Are you sure you want to archive ${client.title}?`,
                  'Archive'
                )
              "
              type="button"
              :disabled="formState.$invalid"
            >
              Archive
            </button>
          </div>
          <template
            v-if="
              currentTab === 'tab1' ||
                currentTab === 'displayTab' ||
                currentTab === 'imageTab' ||
                (currentTab === 'tab2' && tabs.length > 2) ||
                (currentTab === 'tab3' && tabs.length > 3)
            "
          >
            <button
              class="btn btn-secondary"
              v-if="clientId"
              @click="saveAndClose"
              :disabled="formState.$invalid || saveRunning"
            >
              Save And Close
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              @click="saveAndContinue"
              :disabled="formState.$invalid || saveRunning"
            >
              Save + continue
            </button>
          </template>
          <template v-else>
            <div class="c__btn--container">
              <button
                class="btn btn-primary"
                @click="saveClient('published')"
                :disabled="formState.$invalid || saveRunning"
                type="submit"
              >
                Save
              </button>
            </div>
          </template>
        </div>
      </vue-form>
      <result-message :errors="errors"></result-message>
    </template>
  </modal>
</template>

<script>
import Tabs from 'vue-tabs-with-active-line';

import Modal from '../../helpers/Modal';
import CloseButton from '../../helpers/CloseButton';
import ResultMessage from '../../helpers/ResultMessage';

import ClientServices from '../../services/clients';
import AgencyServices from '../../services/agencies';
import PaymentServices from '../../services/payment';

import CreditCardSave from '../CreditCard/CreditCardSave';

import ClientPerimeters from '../../configs/Perimeters/clients';
import ClientDetails from './ClientFormTabs/ClientDetails.vue';
import ClientDisplayConfig from './ClientFormTabs/ClientDisplayConfig.vue';
import ClientImages from './ClientFormTabs/ClientImages.vue';
import FileServices from '../../services/files';
import DeleteAction from '../../mixins/DeleteAction';
import FeaturesTable from '../Features/FeaturesTable.vue';
import URLHelpers from '../../helpers/URLHelpers';

export default {
  perimeters: [ClientPerimeters],
  mixins: [DeleteAction],
  name: 'ModalClient',
  props: {
    clientId: {
      default: null,
    },
    integrationTypes: {
      type: Array,
      default: () => ['', 'CRM', 'XML'],
    },
    australianStates: {
      type: Array,
      default: () => [
        '',
        'Australian Capital Territory',
        'New South Wales',
        'Victoria',
        'South Australia',
        'Queensland',
        'Western Australia',
        'Northern Territory',
        'Tasmania',
      ],
    },
  },
  components: {
    ResultMessage,
    CreditCardSave,
    Modal,
    Tabs,
    CloseButton,
    ClientDetails,
    ClientDisplayConfig,
    ClientImages,
    FeaturesTable,
  },
  computed: {
    filteredAgencies: function() {
      return this.agencies.filter((agency) => {
        return agency.displayName
          .toLowerCase()
          .match(this.search.toLowerCase());
      });
    },
  },
  data() {
    return {
      search: '',
      errors: {
        type: Object | Error,
        $clean: true,
      },
      formState: {},
      currentTab: 'tab1',
      tabs: [
        {
          title: 'Details',
          value: 'tab1',
        },
        {
          title: 'Display',
          value: 'displayTab',
        },
        {
          title: 'Images',
          value: 'imageTab',
        },
      ],
      client: {
        address: {},
        clientIntegration: {},
        billingAddress: {},
        clientDisplayConfig: {},
        ordersReport: {
          recurrencePattern: {
            type: 'weekly',
            interval: 1,
            weekday: 'Mon',
            monthday: 15,
          },
          recurrenceRange: {
            start: null,
            end: {
              type: 'date',
              value: {
                occurrences: 1,
                date: null,
              },
            },
          },
          recipientLists: [],
        },
      },
      agencies: [],
      unavailableAgencies: [],
      created: false,
      cards: [],
      emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      emailListReg: /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/,
      saveRunning: false,
    };
  },
  methods: {
    canEditDisplayConfig() {
      return ClientPerimeters.isAllowed('editDisplayConfig');
    },
    canEditMainFields() {
      return ClientPerimeters.isAllowed('editMainFields');
    },
    canChangePaymentOption() {
      return ClientPerimeters.isAllowed('changePaymentOption');
    },
    canChangeClientCard() {
      return ClientPerimeters.isAllowed('changeClientCard');
    },
    canEditTradingTerms() {
      return ClientPerimeters.isAllowed('editTradingTerms');
    },
    isEmailValid: function() {
      return this.client.accountEmail == '' ||
        typeof this.client.accountEmail == 'undefined'
        ? true
        : this.emailReg.test(this.client.accountEmail)
        ? true
        : false;
    },
    isDomainsValid: function() {
      console.log('Is domains valid');
      if (this.client && !this.client.clientDomains) return true;

      let isValid = true;

      const domains = this.client.clientDomains
        .split(',')
        .map((domain) => domain.replace(/\s/, ''));
      console.log('🚀 ~ domains:', domains);

      domains.forEach((domain) => {
        if (false === URLHelpers.isValidDomain(domain)) {
          isValid = false;
        }
      });

      return isValid;
    },
    isEmailListValid: function() {
      return this.client.ordersReport.recipients == '' ||
        typeof this.client.ordersReport.recipients == 'undefined'
        ? true
        : this.emailListReg.test(
            this.client.ordersReport.recipients.replace(/\s/g, '')
          )
        ? true
        : false;
    },
    closeModal() {
      this.$emit('closeModal');
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    changePermission(permission) {
      ClientServices.updatePermission(this.client, permission).then(
        (permission) => {}
      );
    },
    getCards(clientId) {
      PaymentServices.getClientCards(clientId).then((cards) => {
        if (cards) {
          this.cards = cards;
        }
      });
    },
    saveCard(token) {
      let card = {
        token: token,
      };
      PaymentServices.addClientCard(this.client.id, card).then((cards) => {
        this.getCards(this.client.id);
      });
    },
    removeCard(card) {
      PaymentServices.deleteClientCard(this.client.id, card).then((cards) => {
        this.cards = cards.data;
      });
    },
    getClient(clientId) {
      ClientServices.getClient(
        clientId,
        'agencies,billingAddress,clientIntegration,ordersReport'
      ).then((client) => {
        ClientServices.getClientDisplayConfig(
          clientId,
          'imageLogo,imageLogoInverse,imageAdLogo,imageFavicon,imageEmailLogoTop,imageEmailLogoBottom,imageLandingPageCover'
        ).then((clientDisplayConfig) => {
          this.$set(client, 'clientDisplayConfig', clientDisplayConfig);
        });
        this.client = client;
        if (typeof client.ordersReport == 'undefined') {
          this.client.ordersReport = {
            recurrencePattern: {
              type: 'weekly',
              interval: 1,
              weekday: 'Mon',
              monthday: 15,
            },
            recurrenceRange: {
              start: null,
              end: {
                type: 'date',
                value: {
                  occurrences: 1,
                  date: null,
                },
              },
            },
            recipientLists: [],
          };
        }
        this.getAgencies('published');
        this.getCards(client.id);
      });
    },
    async updateClient(
      logoFormData,
      logoInverseFormData,
      adLogoFormData,
      faviconFormData,
      emailLogoTopFormData,
      emailLogoBottomFormData,
      landingPageCoverFormData,
      closeModal = true
    ) {
      this.saveRunning = true;
      await this.uploadClientImages(
        logoFormData,
        logoInverseFormData,
        adLogoFormData,
        faviconFormData,
        emailLogoTopFormData,
        emailLogoBottomFormData,
        landingPageCoverFormData
      );

      ClientServices.updateClient(this.client)
        .then((client) => {
          ClientServices.getClientDisplayConfig(
            client.id,
            'imageLogo,imageLogoInverse,imageAdLogo,imageFavicon,imageEmailLogoTop,imageEmailLogoBottom,imageLandingPageCover'
          )
            .then((clientDisplayConfig) => {
              this.$set(client, 'clientDisplayConfig', clientDisplayConfig);

              this.client = client;
              this.saveRunning = false;
              if (closeModal) {
                this.$emit('closeModal');
              }
            })
            .catch((errors) => {
              this.errors = errors;
              this.saveRunning = false;
            });
        })
        .catch((errors) => {
          this.errors = errors;
          this.saveRunning = false;
        });
    },
    addAgency(agency) {
      ClientServices.updateAgency(this.client, agency).then((result) => {
        this.getClient(this.client.id);
      });
    },
    updateAgency(agency) {
      if (agency.imageLogo && typeof agency.imageLogo == 'object') {
        agency.imageLogo = agency.imageLogo.id;
      }
      AgencyServices.updateAgency(agency).then((result) => {});
    },
    getAgencies(status) {
      this.agencies = [];
      this.unavailableAgencies = [];
      AgencyServices.getAgencies(status, 'client', '', null, null, -1).then(
        (agencies) => {
          let vue = this;
          agencies.data.forEach(function(agencyItem) {
            if (!agencyItem.client) {
              vue.agencies.push(agencyItem);
            } else if (agencyItem.client.id === vue.client.id) {
              agencyItem.attached = true;
              vue.agencies.push(agencyItem);
            } else {
              vue.unavailableAgencies.push(agencyItem);
            }
          });
        }
      );
    },
    async createClient(
      logoFormData,
      logoInverseFormData,
      adLogoFormData,
      faviconFormData,
      emailLogoTopFormData,
      emailLogoBottomFormData,
      landingPageCoverFormData
    ) {
      this.saveRunning = true;
      await this.uploadClientImages(
        logoFormData,
        logoInverseFormData,
        adLogoFormData,
        faviconFormData,
        emailLogoTopFormData,
        emailLogoBottomFormData,
        landingPageCoverFormData
      );

      ClientServices.createClient(this.client)
        .then((client) => {
          ClientServices.getClientDisplayConfig(
            client.id,
            'imageLogo,imageLogoInverse,imageAdLogo,imageFavicon,imageEmailLogoTop,imageEmailLogoBottom,imageLandingPageCover'
          )
            .then((clientDisplayConfig) => {
              this.$set(client, 'clientDisplayConfig', clientDisplayConfig);
              this.client = client;
              this.created = true;
              this.saveRunning = false;
              this.getAgencies('published');
            })
            .catch((errors) => {
              this.errors = errors;
              this.saveRunning = false;
            });
        })
        .catch((errors) => {
          this.errors = errors;
          this.saveRunning = false;
        });
    },
    saveClient(status) {
      let logoFormData = null;
      let logoInverseFormData = null;
      let adLogoFormData = null;
      let faviconFormData = null;
      let emailLogoTopFormData = null;
      let emailLogoBottomFormData = null;
      let landingPageCoverFormData = null;
      if (
        this.$refs.imageFormRef.$refs.logoRef &&
        typeof this.$refs.imageFormRef.$refs.logoRef.uploadFile.size !==
          'undefined'
      ) {
        logoFormData = new FormData();
        logoFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.logoRef.uploadFile
        );
        logoFormData.append('subType', 'logo');
      }
      if (
        this.$refs.imageFormRef.$refs.logoInverseRef &&
        typeof this.$refs.imageFormRef.$refs.logoInverseRef.uploadFile.size !==
          'undefined'
      ) {
        logoInverseFormData = new FormData();
        logoInverseFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.logoInverseRef.uploadFile
        );
        logoInverseFormData.append('subType', 'logo-inverse');
      }
      if (
        this.$refs.imageFormRef.$refs.adLogoRef &&
        typeof this.$refs.imageFormRef.$refs.adLogoRef.uploadFile.size !==
          'undefined'
      ) {
        adLogoFormData = new FormData();
        adLogoFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.adLogoRef.uploadFile
        );
        adLogoFormData.append('subType', 'ad-logo');
      }
      if (
        this.$refs.imageFormRef.$refs.faviconRef &&
        typeof this.$refs.imageFormRef.$refs.faviconRef.uploadFile.size !==
          'undefined'
      ) {
        faviconFormData = new FormData();
        faviconFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.faviconRef.uploadFile
        );
        faviconFormData.append('subType', 'favicon');
      }
      if (
        this.$refs.imageFormRef.$refs.emailLogoTopRef &&
        typeof this.$refs.imageFormRef.$refs.emailLogoTopRef.uploadFile.size !==
          'undefined'
      ) {
        emailLogoTopFormData = new FormData();
        emailLogoTopFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.emailLogoTopRef.uploadFile
        );
        emailLogoTopFormData.append('subType', 'email-logo');
      }
      if (
        this.$refs.imageFormRef.$refs.emailLogoBottomRef &&
        typeof this.$refs.imageFormRef.$refs.emailLogoBottomRef.uploadFile
          .size !== 'undefined'
      ) {
        emailLogoBottomFormData = new FormData();
        emailLogoBottomFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.emailLogoBottomRef.uploadFile
        );
        emailLogoBottomFormData.append('subType', 'email-logo');
      }
      if (
        this.$refs.imageFormRef.$refs.landingPageCoverRef &&
        typeof this.$refs.imageFormRef.$refs.landingPageCoverRef.uploadFile
          .size !== 'undefined'
      ) {
        landingPageCoverFormData = new FormData();
        landingPageCoverFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.landingPageCoverRef.uploadFile
        );
        landingPageCoverFormData.append('subType', 'landing-page-cover');
      }
      this.client.status = status;
      this.updateClient(
        logoFormData,
        logoInverseFormData,
        adLogoFormData,
        faviconFormData,
        emailLogoTopFormData,
        landingPageCoverFormData
      );
    },
    /**
     * A wrapper around the saveClient() function to accommodate the
     * DeleteAction mixin callback.
     */
    deleteItem() {
      this.saveClient('archive');
    },
    saveAndContinue() {
      this.tabs[1].disabled = false;
      let logoFormData = null;
      let logoInverseFormData = null;
      let adLogoFormData = null;
      let faviconFormData = null;
      let emailLogoTopFormData = null;
      let emailLogoBottomFormData = null;
      let landingPageCoverFormData = null;
      if (
        this.$refs.imageFormRef.$refs.logoRef &&
        typeof this.$refs.imageFormRef.$refs.logoRef.uploadFile.size !==
          'undefined'
      ) {
        logoFormData = new FormData();
        logoFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.logoRef.uploadFile
        );
        logoFormData.append('subType', 'logo');
      }
      if (
        this.$refs.imageFormRef.$refs.logoInverseRef &&
        typeof this.$refs.imageFormRef.$refs.logoInverseRef.uploadFile.size !==
          'undefined'
      ) {
        logoInverseFormData = new FormData();
        logoInverseFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.logoInverseRef.uploadFile
        );
        logoInverseFormData.append('subType', 'logo-inverse');
      }
      if (
        this.$refs.imageFormRef.$refs.adLogoRef &&
        typeof this.$refs.imageFormRef.$refs.adLogoRef.uploadFile.size !==
          'undefined'
      ) {
        adLogoFormData = new FormData();
        adLogoFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.adLogoRef.uploadFile
        );
        adLogoFormData.append('subType', 'ad-logo');
      }
      if (
        this.$refs.imageFormRef.$refs.faviconRef &&
        typeof this.$refs.imageFormRef.$refs.faviconRef.uploadFile.size !==
          'undefined'
      ) {
        faviconFormData = new FormData();
        faviconFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.faviconRef.uploadFile
        );
        faviconFormData.append('subType', 'favicon');
      }
      if (
        this.$refs.imageFormRef.$refs.emailLogoTopRef &&
        typeof this.$refs.imageFormRef.$refs.emailLogoTopRef.uploadFile.size !==
          'undefined'
      ) {
        emailLogoTopFormData = new FormData();
        emailLogoTopFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.emailLogoTopRef.uploadFile
        );
        emailLogoTopFormData.append('subType', 'email-logo');
      }
      if (
        this.$refs.imageFormRef.$refs.emailLogoBottomRef &&
        typeof this.$refs.imageFormRef.$refs.emailLogoBottomRef.uploadFile
          .size !== 'undefined'
      ) {
        emailLogoBottomFormData = new FormData();
        emailLogoBottomFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.emailLogoBottomRef.uploadFile
        );
        emailLogoBottomFormData.append('subType', 'email-logo');
      }
      if (
        this.$refs.imageFormRef.$refs.landingPageCoverRef &&
        typeof this.$refs.imageFormRef.$refs.landingPageCoverRef.uploadFile
          .size !== 'undefined'
      ) {
        landingPageCoverFormData = new FormData();
        landingPageCoverFormData.append(
          'image',
          this.$refs.imageFormRef.$refs.landingPageCoverRef.uploadFile
        );
        landingPageCoverFormData.append('subType', 'landing-page-cover');
      }
      if (this.currentTab === 'tab1') {
        if (
          !this.isEmailValid() ||
          !this.isEmailListValid() ||
          !this.isDomainsValid()
        ) {
          return;
        }
        this.currentTab = 'displayTab';
      } else if (this.currentTab === 'displayTab') {
        this.currentTab = 'imageTab';
      } else if (this.currentTab === 'imageTab') {
        /* Move to the next tab depending on what tabs are active based on user permission */
        if (
          typeof this.tabs.find((element) => element.value === 'tab2') !=
          'undefined'
        ) {
          this.currentTab = 'tab2';
        } else if (
          typeof this.tabs.find((element) => element.value === 'tab3') !=
          'undefined'
        ) {
          this.currentTab = 'tab3';
        } else this.currentTab = 'tab4';
      } else if (this.currentTab === 'tab2') {
        this.currentTab = 'tab3';
      } else if (this.currentTab === 'tab3') {
        this.currentTab = 'tab4';
      }

      if (!this.clientId && !this.created) {
        this.createClient(
          logoFormData,
          logoInverseFormData,
          adLogoFormData,
          faviconFormData,
          emailLogoTopFormData,
          emailLogoBottomFormData,
          landingPageCoverFormData
        );
      } else {
        this.updateClient(
          logoFormData,
          logoInverseFormData,
          adLogoFormData,
          faviconFormData,
          emailLogoTopFormData,
          emailLogoBottomFormData,
          landingPageCoverFormData,
          false
        );
      }
    },
    async uploadClientImages(
      logoFormData,
      logoInverseFormData,
      adLogoFormData,
      faviconFormData,
      emailLogoTopFormData,
      emailLogoBottomFormData,
      landingPageCoverFormData
    ) {
      const promises = [];
      if (logoFormData) {
        promises.push(
          FileServices.uploadFile(logoFormData)
            .then((imageLogo) => {
              this.client.clientDisplayConfig.imageLogo = imageLogo.id;
            })
            .catch((errors) => {
              this.errors = errors;
            })
        );
      } else if (this.client.clientDisplayConfig.imageLogo) {
        this.client.clientDisplayConfig.imageLogo = this.client.clientDisplayConfig.imageLogo.id;
      }
      if (logoInverseFormData) {
        promises.push(
          FileServices.uploadFile(logoInverseFormData)
            .then((imageLogoInverse) => {
              this.client.clientDisplayConfig.imageLogoInverse =
                imageLogoInverse.id;
            })
            .catch((errors) => {
              this.errors = errors;
            })
        );
      } else if (this.client.clientDisplayConfig.imageLogoInverse) {
        this.client.clientDisplayConfig.imageLogoInverse = this.client.clientDisplayConfig.imageLogoInverse.id;
      }
      if (adLogoFormData) {
        promises.push(
          FileServices.uploadFile(adLogoFormData)
            .then((imageAdLogo) => {
              this.client.clientDisplayConfig.imageAdLogo = imageAdLogo.id;
            })
            .catch((errors) => {
              this.errors = errors;
            })
        );
      } else if (this.client.clientDisplayConfig.imageAdLogo) {
        this.client.clientDisplayConfig.imageAdLogo = this.client.clientDisplayConfig.imageAdLogo.id;
      }
      if (faviconFormData) {
        promises.push(
          FileServices.uploadFile(faviconFormData)
            .then((imageFavicon) => {
              this.client.clientDisplayConfig.imageFavicon = imageFavicon.id;
            })
            .catch((errors) => {
              this.errors = errors;
            })
        );
      } else if (this.client.clientDisplayConfig.imageFavicon) {
        this.client.clientDisplayConfig.imageFavicon = this.client.clientDisplayConfig.imageFavicon.id;
      }
      if (emailLogoTopFormData) {
        promises.push(
          FileServices.uploadFile(emailLogoTopFormData)
            .then((imageEmailLogoTop) => {
              this.client.clientDisplayConfig.imageEmailLogoTop =
                imageEmailLogoTop.id;
            })
            .catch((errors) => {
              this.errors = errors;
            })
        );
      } else if (this.client.clientDisplayConfig.imageEmailLogoTop) {
        this.client.clientDisplayConfig.imageEmailLogoTop = this.client.clientDisplayConfig.imageEmailLogoTop.id;
      }
      if (emailLogoBottomFormData) {
        promises.push(
          FileServices.uploadFile(emailLogoBottomFormData)
            .then((imageEmailLogoBottom) => {
              this.client.clientDisplayConfig.imageEmailLogoBottom =
                imageEmailLogoBottom.id;
            })
            .catch((errors) => {
              this.errors = errors;
            })
        );
      } else if (this.client.clientDisplayConfig.imageEmailLogoBottom) {
        this.client.clientDisplayConfig.imageEmailLogoBottom = this.client.clientDisplayConfig.imageEmailLogoBottom.id;
      }
      if (landingPageCoverFormData) {
        promises.push(
          FileServices.uploadFile(landingPageCoverFormData)
            .then((imageLandingPageCover) => {
              this.client.clientDisplayConfig.imageLandingPageCover =
                imageLandingPageCover.id;
            })
            .catch((errors) => {
              this.errors = errors;
            })
        );
      } else if (this.client.clientDisplayConfig.imageLandingPageCover) {
        this.client.clientDisplayConfig.imageLandingPageCover = this.client.clientDisplayConfig.imageLandingPageCover.id;
      }

      await Promise.allSettled(promises).then(() => {
        return;
      });
    },
    saveAndClose() {
      this.saveClient('published').then(() => {
        this.closeModal();
      });
    },
  },
  created() {
    if (ClientPerimeters.isAllowed('viewOfficesTab')) {
      this.tabs.push({
        title: 'Offices',
        value: 'tab2',
      });
    }

    if (ClientPerimeters.isAllowed('viewIntegrationTab')) {
      this.tabs.push({
        title: 'Integration',
        value: 'tab3',
      });
    }

    if (ClientPerimeters.isAllowed('viewPaymentDetails')) {
      this.tabs.push({
        title: 'Payment Details',
        value: 'tab4',
      });
    }

    if (ClientPerimeters.isAdmin() || ClientPerimeters.isSuperAdmin()) {
      this.tabs.push({
          title: "Features",
          value: "featuresTab"
        });
    }
    

    if (this.clientId) {
      this.getClient(this.clientId);
    } else {
      this.tabs[1].disabled = true;
    }
  },
  mounted() {},
};
</script>
